/* Thumbnail changes stay inside their gallery, including dynamically rendered sections. */
if (!customElements.get('purrify-gallery')) {
  customElements.define('purrify-gallery', class extends HTMLElement {
    constructor() {
      super();
      this.onGalleryClick = this.onGalleryClick.bind(this);
      this.onGalleryKeydown = this.onGalleryKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onGalleryClick);
      this.addEventListener('keydown', this.onGalleryKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onGalleryClick);
      this.removeEventListener('keydown', this.onGalleryKeydown);
    }

    onGalleryClick(event) {
      const button = event.target.closest('[data-pmp-thumbnail]');
      if (button && button.closest('purrify-gallery') === this) this.selectImage(button);
    }

    onGalleryKeydown(event) {
      const button = event.target.closest('[data-pmp-thumbnail]');
      if (!button || button.closest('purrify-gallery') !== this) return;
      const buttons = [...this.querySelectorAll('[data-pmp-thumbnail]')];
      const index = buttons.indexOf(button);
      const rtl = getComputedStyle(this).direction === 'rtl';
      let next;
      if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + buttons.length) % buttons.length;
      else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + buttons.length) % buttons.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else return;
      event.preventDefault();
      this.selectImage(buttons[next]);
      buttons[next].focus({ preventScroll: true });
      buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    selectImage(button) {
      const image = this.querySelector('[data-pmp-main-image]');
      const stage = this.querySelector('[data-pmp-image-stage]');
      if (!image || !stage || !button.dataset.pmpImageSrc) return;
      stage.dataset.mode = button.dataset.pmpImageMode;
      image.src = button.dataset.pmpImageSrc;
      image.alt = button.dataset.pmpImageAlt;
      image.height = Number(button.dataset.pmpImageHeight) || 2048;
      const buttons = [...this.querySelectorAll('[data-pmp-thumbnail]')];
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const status = this.querySelector('[data-pmp-image-status]');
      if (status) status.textContent = `Image ${buttons.indexOf(button) + 1} of ${buttons.length}: ${image.alt}`;
    }
  });
}
